import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Hero from "../sections/Hero";
import Mission from "../sections/Mission";
import Capabilities from "../sections/Capabilities";
import Technology from "../sections/Technology";
import Showcase from "../sections/Showcase";
import Philosophy from "../sections/Philosophy";
import GlobalPresence from "../sections/GlobalPresence";
import FinalCTA from "../sections/FinalCTA";
import ContactForm from "../sections/ContactForm";

export default function Home() {
  return (
    <div className="bg-black text-white min-h-screen">
      <Navbar />
      <main>
        <Hero />
        <Mission />
        <Capabilities />
        <Technology />
        <Showcase />
        <Philosophy />
        <GlobalPresence />
        <FinalCTA />
        <ContactForm />
      </main>
      <Footer />
    </div>
  );
}
